import React from 'react';

const LoaderView = () => (
    <div className="bz-loader">
        <i className="fa fa-spinner fa-spin fa-2x"/>
    </div>
);

export default LoaderView;
